const ResetPasswordConfirm = () => {
  return (
  <h1>
    An email was sent to recover your account
  </h1>);
}
export default ResetPasswordConfirm;